export const CLIENTSREDUCER = (state = { ic_box_user: { list: [], search_results: [], search_text: '', user_to_update: {} }, addingClientStatus: false, primary_tabs_list: [], is_ic_select: false, isClient: null, access_categories: [] }, action) => {
  switch (action.type) {
    case 'SET_PRIMARY_TABS_LIST':
      return {
        ...state,
        primary_tabs_list: action.data
      };
    case 'SET_ACCESS_CATEGORIES_LIST':
      return {
        ...state,
        access_categories: action.data
      }
    case 'SET_IS_IC_SELECT':
      return {
        ...state,
        is_ic_select: action.data
      };
    case 'SET_IS_CLIENT':
      return {
        ...state,
        isClient: action.data
      };
    case 'SET_ADDING_CLIENT_STATUS':
      return {
        ...state,
        addingClientStatus: action.data
      };
    case 'SET_IC_BOX_USER_LIST':
      state.ic_box_user.list = action.data;
      return {
        ...state
      };
    case 'SET_IC_BOX_USER_SEARCH':
      state.ic_box_user.search_results = action.data;
      return {
        ...state
      };
    case 'SET_IC_BOX_USER_SEARCH_TEXT':
      state.ic_box_user.search_text = action.data;
      return {
        ...state
      };
    case 'SET_IC_BOX_USER_TO_UPDATE':
      console.log(action.data, 'USER DATA')
      state.ic_box_user.user_to_update = action.data;
      return {
        ...state
      };
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/redux/reducers/Client/ClientsReducer.js